import React from 'react';

const CriticalCss = () => {
  return (
    <style scoped>
      {`
            :root {
  --primary: #e9a43f;
  --new-primary: #f4970d;
  --new-primary-light: #ffc552;
  --secondary: #666;
  --new-secondary: #4A4A4A;
  --new-secondary-light: #7A7A7A;
  --tint: #faebd6;
  --shade: #bf9860;
  --shade2: #d6850a;
  --border: #F6F6F6;
  --border-primary: #F08F00;
  --danger: #E82222;
  --success: #0CBF29;
  --page-padding: 1.4rem;
  --saudi: #005430;
  --founding: #000000;
  --secondary-founding: #FFF200;

}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  line-height: 1.4;
}

html {
  direction: rtl;
}

.d-flex {
  display: flex;
}

.flex-column {
  flex-direction: column;
}

.align-items-center {
  align-items: center;
}
.align-self-start {
  align-self: flex-start;
}

.justify-content-center {
  justify-content: center;
}

.justify-content-right {
  justify-content: flex-end;
}

.text-center {
  text-align: center;
  padding-inline:8px !important;
}

.text-left {
  text-align: left;
}
.position-relative {
  position: relative;
}
.font-weight-bold {
  font-weight: bold;
}

.text-white {
  color: white;
}
.text-muted {
  color: #6c757d;
}

.px-3 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-4 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.h1 {
  font-size: 2.8rem;
}

.h5,
h5 {
  font-size: 1.25rem;
}

.h4,
h4 {
  font-size: 1.5rem;
}

.text-danger {
  color: #dc3545;
}

.text-dark {
  color: #343a40;
}
.h2,
h2 {
  font-size: 2rem;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.pb-4 {
  padding-bottom: 1.5rem;
}

.flex-wrap {
  flex-wrap: wrap;
}

.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.ml-2 {
  margin-left: 0.5rem;
}

.my-4 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

.h3 {
  font-size: 1.75rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.btn-primary {
  color: #fff;
  background-color: var(--primary);
  border-color: var(--primary);
}

.btn-primary:focus,
.btn-primary:active,
.btn-primary:hover {
  color: #fff;
  background-color: var(--shade2) !important;
  border-color: var(--shade2) !important;
}

.grid {
  display: grid;
}

.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-3 {
  margin-bottom: 1rem;
}

.pt-3 {
  padding-top: 1rem;
}

.d-none {
  display: none;
}

.mx-3 {
  margin-left: 1rem;
  margin-right: 1rem;
}

.justify-content-between {
  justify-content: space-between !important;
}

.flex-start {
  align-items: flex-start;
}

.close:focus,
.close:hover,
.close:active {
  text-decoration: none;
  outline: 0;
}

.flex-row-reverse {
  flex-direction: row-reverse;
}

.vh-100 {
  height: 100dvh;
}
.w-100 {
  width: 100%;
}

            `}
    </style>
  );
};

export default React.memo(CriticalCss);
